import { DatalayerService } from '@analytics/datalayer';
import type { Commerce, ProductEventType } from '@analytics/models';
import { inject, Injectable } from '@angular/core';

/**
 * @deprecated please use the TrackProductDirective in your templates instead of accessing this service.
 */
@Injectable({
  providedIn: 'root',
})
export class TrackProductService {
  readonly #datalayer = inject(DatalayerService);

  /**
   * @deprecated please use the TrackProductDirective in your templates instead of accessing this service.
   */
  public trackImpression(product: Commerce) {
    this.#pushEventToDatalayer('product-impression', product);
  }

  public trackSelection(product: Commerce) {
    this.#pushEventToDatalayer('product-click', product);
  }

  /**
   * @deprecated please use the TrackProductDirective in your templates instead of accessing this service.
   */
  public trackDetail(subject: Commerce) {
    this.#pushEventToDatalayer('product-detail', subject);
  }

  #pushEventToDatalayer(eventType: ProductEventType, product: Commerce) {
    return this.#datalayer.pushEvent({
      event: eventType,
      info: {
        commerce: [product],
      },
    });
  }
}
